import { PRIVILEGES } from './permissions';

/** Privileges that count as a “page” anchor for Sync Option. */
export const SYNC_OPTION_ANCHOR_PRIVILEGES = [
  PRIVILEGES.STANDUP,
  PRIVILEGES.ENG_METRICS,
  PRIVILEGES.CXO_ENGINEERING_SCORE,
  PRIVILEGES.CXO_RELEASE_READINESS,
];

/** CXO widgets that must accompany CXO Board Metric Contribution. */
export const CXO_CONTRIBUTION_REQUIRED_WIDGETS = [
  PRIVILEGES.CXO_ENGINEERING_SCORE,
  PRIVILEGES.CXO_RELEASE_READINESS,
];

/**
 * Validate privilege set before create/update role (all roles).
 * @returns {{ valid: true } | { valid: false, message: string }}
 */
export function validateRolePrivileges(privileges = []) {
  const privs = Array.isArray(privileges) ? privileges : [];

  if (privs.includes(PRIVILEGES.CXO_METRIC_CONTRIBUTION)) {
    const hasRequiredWidget = CXO_CONTRIBUTION_REQUIRED_WIDGETS.some((key) =>
      privs.includes(key),
    );
    if (!hasRequiredWidget) {
      return {
        valid: false,
        message:
          'CXO Board Metric Contribution requires selecting CXO Widget: Engineering Score and/or CXO Widget: Release Readiness.',
      };
    }
  }

  if (privs.includes(PRIVILEGES.SYNC_OPTION)) {
    const hasAnchor = SYNC_OPTION_ANCHOR_PRIVILEGES.some((key) => privs.includes(key));
    if (!hasAnchor) {
      return {
        valid: false,
        message:
          'Sync Option requires at least one page access privilege: Standup, Eng Metrics Page, CXO Widget: Engineering Score, or CXO Widget: Release Readiness.',
      };
    }
  }

  if (privs.includes(PRIVILEGES.MULTI_PROJECT) && !privs.includes(PRIVILEGES.STANDUP)) {
    return {
      valid: false,
      message: 'Multi Project requires selecting Standup as well.',
    };
  }

  if (privs.includes(PRIVILEGES.CAPACITY_TABLE) && !privs.includes(PRIVILEGES.STANDUP)) {
    return {
      valid: false,
      message: 'Capacity Table requires selecting Standup as well.',
    };
  }

  if (privs.includes(PRIVILEGES.INTEGRATION_SETUP) && !privs.includes(PRIVILEGES.INTEGRATION_PAGE)) {
    return {
      valid: false,
      message:
        'Integration (Roles, Rate Card, Holidays) requires selecting Integration Page as well.',
    };
  }

  if (privs.includes(PRIVILEGES.BILLING_RATE) && !privs.includes(PRIVILEGES.INTEGRATION_PAGE)) {
    return {
      valid: false,
      message:
        'Billing Rate / Total Billing Rate requires selecting Integration Page as well.',
    };
  }

  return { valid: true };
}
